/** 空调公摊组列表 /metering/fee/conditioningSharing */
export default {
  conditioningSharing: {
    phGroupId: '请输入公摊组编号',
    phGroupName: '请输入公摊组名称',
    phShareType: '公摊方式',
    btnSearch: '查询',
    btnReset: '重置',
    btnExport: '导出',
    listTitle: '空调公摊组列表',
    btnAdd: '新增',
    sortDefault: '默认排序',
    colId: '公摊组编号',
    colName: '公摊组名',
    colShareType: '公摊方式',
    colTenantCount: '公摊租户数',
    colAirCount: '公摊设备数',
    colUpdateTime: '更新时间',
    colActions: '操作',
    opDetail: '详情',
    opEdit: '编辑',
    opDelete: '删除',
    emptyDesc: '暂无数据',
    dialogAddTitle: '新增空调公摊组',
    dialogEditTitle: '编辑空调公摊组',
    formName: '公摊组名',
    formShareType: '公摊方式',
    phFormName: '请输入公摊组名',
    phFormShareType: '请选择公摊方式',
    btnCancel: '取 消',
    btnConfirm: '确 定',
    btnSubmitting: '提交中...',
    shareTypeArea: '面积占比',
    shareTypeEnergy: '能耗占比',
    msgFetchFail: '获取数据失败',
    msgFetchListFail: '获取空调公摊组数据失败',
    msgNoViewPermission: '无查看权限',
    msgNoAddEditPermission: '无新增/编辑权限',
    msgNoDeletePermission: '无删除权限',
    msgExportEmpty: '暂无数据可导出',
    msgExportOk: '成功导出{count}条数据',
    msgExportFail: '导出失败',
    exportSheetName: '空调公摊组',
    exportFilePrefix: '空调公摊组_',
    confirmDeleteTitle: '提示',
    confirmDeleteMsg: '删除公摊组将同时移除公摊组关联的租户和空调，确认删除吗?',
    confirmOk: '确定',
    confirmCancel: '取消',
    msgDeleteOk: '删除成功',
    msgDeleteFail: '删除失败',
    confirmGroupTitle: '提示',
    confirmGroupAdd: '确认新增空调公摊组?',
    confirmGroupEdit: '确认编辑空调公摊组?',
    msgAddOk: '新增成功',
    msgEditOk: '编辑成功',
    msgAddFail: '新增失败',
    msgEditFail: '编辑失败',
    ruleNameRequired: '请输入公摊组名',
    ruleNameLen: '长度在 1 到 50 个字符',
    ruleShareTypeRequired: '请选择公摊方式'
  }
}
